
import './App.css';
import {API} from "./elements/containers/API";

function App() {
  return (
    <div className="App">
      <API apiDescriptionUrl="/api/doc.json"
           basePath={process.env.PUBLIC_URL}
           logo={process.env.PUBLIC_URL + '/logo.png'} />
    </div>
  );
}

export default App;
